import {Router} from "../../../stem-core/ui/Router";
import {OAUTH_CONNECT_URL} from "../PanelConstants";
import {BaseFlowHandler} from "./BaseFlowHandler";
import {PANEL_TYPE} from "../../../blink-sdk/Constants";
import {Flow} from "./Flow";


export class OAuthConnectFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.oauthConnect;

    getFlowPlan() {
        return [Flow.auth];
    }

    finalize() {
        Router.changeURL(OAUTH_CONNECT_URL);
    }
}
